import styled from "styled-components";

export const CustomizedChartRatio = styled.div`
  .recharts-legend-wrapper {
    ul {
      display: grid;
      grid-template-columns: repeat(${(props) => Math.ceil(props.items / 2)}, auto);
      grid-template-rows: repeat(2, auto);
    }

    ${(props) => {
      let styles = "";
      for (let i = 1; i <= props.items; i++) {
        const column = Math.ceil(i / 2);
        const row = i % 2 === 0 ? 2 : 1;
        styles += `
          li:nth-child(${i}) {
            grid-column-start: ${column};
            grid-row-start: ${row};
          }
        `;
      }
      return styles;
    }}
  }
`;
